 //WHEN CHECK --> CLICK APPLY
 $(".filter-group-display__list-item label").on("click", function(){
    $(".grid--prod-archive").animate({ opacity: .5 }, 100);
    $(".filter-group-display__submit input[type='submit']").click();
})
//OPEN FILTER
$("#FacetFiltersForm .filter__title").on("click", function(){
    var filter = $(this).closest(".filter");
    $('.filter').not(filter).removeClass('open');
    filter.toggleClass("open");
});

$("body").on("click", function(e){
    if (!$(e.target).closest('.filter__title, .filter-group-display').length) {
        $('.filter').removeClass('open');
    }
})

//LABEL DISABLED
$('input:disabled').each(function() {
    $(this).parent('label').addClass('label-disabled');
  });

//OPEN FILTERS VERTICAL
$(".icon-filter").on("click", function(){
    $(".facets__content").addClass("open");
});
//CLOSE FILTERS VERTICAL
$(".icon-close-filters").on("click", function(){
    $(".facets__content").removeClass("open");
})
$("body").on("click", function(e){
    if (!$(e.target).closest('.icon-filter, .facets__content').length) {
        $(".facets__content").removeClass('open');
    }
})


